import React, { useState } from 'react'
import { Select, Button, Divider, Space } from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'

interface FilterDropdownSelectProps {
  value: string[]
  onChange: (value: string[]) => void
  onConfirm: () => void
  onClear: () => void
  options: { value: string; label: string }[]
  placeholder?: string
  allowClear?: boolean
  mode?: 'multiple' | 'tags'
  style?: React.CSSProperties
}

const FilterDropdownSelect: React.FC<FilterDropdownSelectProps> = ({
  value,
  onChange,
  onConfirm,
  onClear,
  options,
  placeholder = t('请选择'),
  allowClear = true,
  mode = 'multiple',
  style = { width: '100%' },
}) => {
  const [open, setOpen] = useState(true)

  return (
    <Wrapper>
      <Select
        mode={mode}
        style={style}
        value={value}
        open={open}
        onDropdownVisibleChange={setOpen}
        getPopupContainer={() => document.body as HTMLElement}
        dropdownClassName="table-filter-dropdown"
        onChange={onChange}
        dropdownRender={menu => (
          <div style={{ marginBottom: '6px' }}>
            {menu}
            <Divider style={{ margin: '3px 0 6px 0' }} />
            <Space className="space-btn" style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                type="default"
                size="small"
                style={{ letterSpacing: '-2px', padding: '0 12px' }}
                onClick={() => {
                  onClear()
                  setOpen(false)
                }}
              >
                {t('重置')}
              </Button>
              <Button
                type="primary"
                size="small"
                style={{ letterSpacing: '-2px', padding: '0 12px', marginRight: 8 }}
                onClick={() => {
                  onConfirm()
                  setOpen(false)
                }}
              >
                {t('确定')}
              </Button>
            </Space>
          </div>
        )}
        options={options}
        placeholder={placeholder}
        allowClear={allowClear}
        filterOption={(input, option) =>
          (option?.label as string)?.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      />
    </Wrapper>
  )
}

export default FilterDropdownSelect
export * from './util'

const Wrapper = styled.div`
  padding: 8px;
  width: 300px;
`
